if(!customElements.get('delivery-estimate-banner')){
    customElements.define('delivery-estimate-banner', class DeliveryEstimateBanner extends HTMLElement{
        constructor(){
            super();
            this.message = this.querySelector('[data-message]');
            this.dataContainer = this.querySelector('[data-delivery-data]');
            this.data = {};

            this.productDetailsContainer = this.closest('[data-product-details]');
            this.variantSelects = this.productDetailsContainer.querySelector('variant-selection');
            if(this.variantSelects){
                this.variantSelects.addEventListener('variant-change', this.handleVariantChange.bind(this))
            }
        }
        connectedCallback(){
            try{
                this.data = JSON.parse(this.dataContainer.innerHTML);
                this.init();
            }
            catch(e){
                this.hide();
            }
        }
        hide(){
            this.setAttribute('hidden', true)
        }
        show(){
            this.removeAttribute('hidden');
        }
        init(){
            this.updateMessageByVariantId(this.dataset.variantId);
        }
        handleVariantChange(e){
            if(e.detail){
                if(e.detail.state == "unavailable"){
                    return this.hide();
                }
                let variantId = e.detail.state == 'selected' ? e.detail.variant.id : e.detail.state
                this.updateMessageByVariantId(variantId);
            }
            else{
                return this.hide();
            }
        }
        updateMessageByVariantId(variantId){
            this.dataset.variantId = variantId;
            let variant = this.data.variantData.find(v => v.id == variantId);
            if(variant == undefined){
                return this.hide();
            }
            if (!variant.available) {
              //if variant is out of stock
              //check to see if it has a message to display
              if (variant.variantSupplierMessage != undefined && variant.variantSupplierMessage != "") {
                this.message.innerText = variant.variantSupplierMessage;
                return this.show();
              } else {
                return this.hide();
              }
            }
            if(variant.main){
                this.showMainDeliveryMessage();
            }
            else if(variant.supplier){
                this.showSupplierMessage();
            }
            else{
                if (variant.variantSupplierMessage != undefined && variant.variantSupplierMessage != "") {
                  this.message.innerText = variant.variantSupplierMessage;
                  return this.show();
                } else {
                  return this.hide();
                }
            }
        }
        showSupplierMessage(){
            if(this.data.supplierDefaultMessage == ''){
                return this.hide();
            }
            this.message.innerText = this.data.supplierDefaultMessage;
            this.show();
        }
        showMainDeliveryMessage(){
            let message = this.generateDeliveryMessage();

            if(message == ''){
                return this.hide();
            }
            this.message.innerText = message;
            this.show();
        }
        getThreeLetterDay(dateObj){
            let options = { weekday: 'short'};
            return new Intl.DateTimeFormat('en-GB', options).format(dateObj);
        }
        getYmdDate(dateObj){
            return dateObj.toISOString().split('T')[0];
        }
        getNiceDate(dateObj){
            let day = dateObj.getDate();
            let month = dateObj.toLocaleString("default", { month: "long" });
            let dayOfWeek = dateObj.toLocaleString("default", { weekday: "long" });

            const nthNumber = (number) => {
                if (number > 3 && number < 21) return "th";
                switch (number % 10) {
                  case 1:
                    return "st";
                  case 2:
                    return "nd";
                  case 3:
                    return "rd";
                  default:
                    return "th";
                }
            };

            return `${dayOfWeek} ${day}${nthNumber(day)} ${month}`;
        }
        getNextDispatchDate(){
            let todaysDate = new Date();
            let nextDispatchDate = new Date();
            if(todaysDate.getHours() >= this.data.cutoffHour){
                //next dispatch is tomorrow
                nextDispatchDate.setDate(nextDispatchDate.getDate() + 1)
            }
            nextDispatchDate = this.getNextAvailableDate(nextDispatchDate)
            return nextDispatchDate;
        }
        getNextAvailableDate(dateObj){
            while(this.data.undeliverableDays.includes(this.getThreeLetterDay(dateObj)) 
                || this.data.undeliverableDates.includes(this.getYmdDate(dateObj))){
                    dateObj.setDate(dateObj.getDate() + 1)
            }
            return dateObj;
        }
        getNextDeliveryDate(dispatchDate){
            let leadTime = parseInt(this.data.deliveryLeadTime);
            let nextDeliveryDate = new Date(dispatchDate.getTime());
            nextDeliveryDate.setDate(nextDeliveryDate.getDate() + leadTime);
            nextDeliveryDate = this.getNextAvailableDate(nextDeliveryDate);
            return nextDeliveryDate;

        }
        generateDeliveryMessage(){
            let deliveryMessage = '';
            let nextDispatchDate = this.getNextDispatchDate();
            let nextDeliveryDate = this.getNextDeliveryDate(nextDispatchDate);

            //convert date object to readable string
            deliveryMessage = this.getNiceDate(nextDeliveryDate);
            return deliveryMessage;
        }
    })
}